import { OidcManager} from "@rhitm-incubator/oidc-manager";

(function (drupalSettings) {
  performance.mark('rh_oidc_manager--start');
  const settings = drupalSettings.rh_oidc_manager;
  const oidcSettings = settings.oidc_settings;
  const rh_sso_session_enabled = 
    settings.cookie_settings.rh_sso_session_enabled;
  const rhSsoSessionCookie = getCookie('rh_sso_session');
  performance.mark('rh_oidc_manager--session-cookie-read');

  // If cookie is not set, do not authenticate automagically.
  if (rh_sso_session_enabled && rhSsoSessionCookie !== '1') {
    oidcSettings.force_redirect = true;
  }

  if (
    oidcSettings.redirect_uri && 
    oidcSettings.authority && 
    oidcSettings.client_id
  ) {
    performance.mark('rh_oidc_manager--create-client-start');
    OidcManager.instance.createClient(oidcSettings);
  }

  if (settings.debug) {
    console.debug(
      'RH OIDC Manager available performance marks:',
      'rh_oidc_manager--start',
      'rh_oidc_manager--session-cookie-read',
      'rh_oidc_manager--create-client-start'
    );
  }

  function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    }
    else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

})(drupalSettings);
